export default class FinanceRegisterModel {
  FinanceRegisterId: number;
  SalesId: number;
  SalesNumber: string;
  CustomerName: string;
  MobileNo: string;
  EmailId: string;
  CustomerAddress: string;
  VehicleId: number;
  VehicleLabel: string;
  VehicleCost: number;
  ChassisNo: string;
  EngineNo: string;
  FinancePartnerId: number;
  FinancePartnerName: string;
  DownPayment: number;
  EMITenure: number;
  ProcessingFees: number;
  InterestRate: number;
  EMIAmount: number;
  LoanApplicationNo: string;
  LoanAccountNumber: string;
  NextEmiDate: string;
  StatusId: number;
  Status: string;

  constructor() {
    this.FinanceRegisterId = 0;
    this.SalesId = 0;
    this.SalesNumber = '';
    this.CustomerName = '';
    this.MobileNo = '';
    this.EmailId = '';
    this.CustomerAddress = '';
    this.VehicleId = 0;
    this.VehicleLabel = '';
    this.VehicleCost = 0;
    this.ChassisNo = '';
    this.EngineNo = '';
    this.FinancePartnerId = 0;
    this.FinancePartnerName = '';
    this.DownPayment = 0;
    this.EMITenure = 0;
    this.ProcessingFees = 0;
    this.InterestRate = 0;
    this.EMIAmount = 0;
    this.LoanApplicationNo = '';
    this.LoanAccountNumber = '';
    this.NextEmiDate = '';
    this.StatusId = 0;
    this.Status = '';
  }
}
